import request from '@/utils/request'
const user_data = [
    {
        pro_name:'电站',
        files:[
            {'name':'battery01_csv'},
            {'name':'battery02_csv'},
            {'name':'battery04_csv'}
        ]
    },
    {
        pro_name:'电动车',
        files:[
            {'name':'battery11_csv'},
            {'name':'battery12_csv'},
            {'name':'battery14_csv'},
            {'name':'battery15_csv'}
        ]
    },
];
export function searchAll(){
    return user_data;
}


const baseUrl = '127.0.0.0:5000';
const response= {
    code:200,
    message:'success',
    data:[{
        code:200,
        message:'success'
    }]
}

export function exportNew(query) {
    return request({
      url: '/fulfillment/person/exportCode',
      method: 'post',
      params: query,
      responseType:'blob',
      headers: { "Content-Type": "multipart/form-data" }
    })
}

export function load(data){
    // console.log(data)
    // return new Promise(function(){return response});
    if(data.UserName==='mks'&&data.PassWord ==="123456"){
        return new Promise(function(){return response});
    }
    else{
        return new Promise();
    }
    // return request({
    //     url:baseUrl+'',
    //     method:'post',
    //     data
    // })
}

export function uploadData(data){
    return new request({
        url:baseUrl+'',
        method:'post',
        data
    });
}
export function downMould(data){
    return new request({
        url:baseUrl+'',
        method:'post',
        data
    });
}